import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface OverviewPoint {
  icon: string;
  title: string;
  description: string;
}

interface ProgramOverviewProps {
  overviewPoints: OverviewPoint[];
}

const ProgramOverview: React.FC<ProgramOverviewProps> = ({ overviewPoints }) => {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-text-primary mb-4 sm:mb-6">
              Integrated Strategy & Capacity Building
            </h2>
            <p className="text-base sm:text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed px-2">
              A comprehensive engagement model that combines strategic framework development with leadership capacity building and implementation architecture over a sustained 6-12 month period.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {overviewPoints.map((point, index) => (
              <div
                key={index}
                className="bg-surface p-6 sm:p-8 rounded-lg institutional-border hover:institutional-shadow transition-base"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-institutional/10 rounded-md flex items-center justify-center mb-4 sm:mb-6">
                  <Icon name={point.icon as any} size={22} className="text-institutional sm:hidden" />
                  <Icon name={point.icon as any} size={24} className="text-institutional hidden sm:block" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-3 sm:mb-4">
                  {point.title}
                </h3>
                <p className="text-sm sm:text-base text-text-secondary leading-relaxed">
                  {point.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramOverview;